import React, { FC, InputHTMLAttributes } from 'react';
import '../form.scss';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

interface InputDatePickerProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  Controller: any;
  control?: any;
  placeholder?: string;
  label?: string;
  error?: any;
  register?: any;
  wrapperClass?: string;
  className?: string;
  isClearable?: boolean;
  disabled?: boolean;
  isTime?: boolean;
  minDate?: Date;
  minTime?: Date;
  maxTime?: Date;
}

const InputDatePicker: FC<InputDatePickerProps> = ({
  placeholder,
  Controller,
  control,
  name,
  error,
  label,
  wrapperClass,
  isClearable = false,
  disabled = false,
  isTime = false,
  minDate,
  minTime,
  maxTime,
  ...rest
}) => {
  return (
    <div className={`${wrapperClass} flex flex-col items-start pb-4 text-sm`}>
      {label && (
        <label className="text-neutral9 font-semibold" htmlFor={name}>
          {label}
        </label>
      )}
      {isTime ? (
        <Controller
          control={control}
          name={name}
          {...rest}
          render={({ field: { onChange, value } }: any) => {
            return (
              <DatePicker
                className="input"
                wrapperClassName="w-full"
                placeholderText={placeholder}
                onChange={onChange}
                selected={value}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15}
                timeCaption="Time"
                dateFormat="h:mm aa"
                minTime={minTime}
                maxTime={maxTime}
                popperContainer={({ children }) => <div>{children}</div>} // To ensure that the popper is not constrained by overflow
                popperProps={{
                  strategy: 'fixed', // TO ensure that the popper has a fixed position strategy so that the popper is positioned relative to the viewport, not constrained by any parent element's overflow
                  modifiers: [
                    {
                      name: 'preventOverflow',
                      options: {
                        boundary: 'viewport'
                      }
                    }
                  ]
                }}
                // isClearable={isClearable}
                // disabled={disabled}
              />
            );
          }}
        />
      ) : (
        <Controller
          control={control}
          name={name}
          {...rest}
          render={({ field: { onChange, value } }: any) => {
            return (
              <DatePicker
                className="input"
                wrapperClassName="w-full"
                placeholderText={placeholder}
                onChange={onChange}
                selected={value}
                dateFormat="MM-dd-yyyy"
                isClearable={isClearable}
                disabled={disabled}
                minDate={minDate}
                popperContainer={({ children }) => <div>{children}</div>}
                popperProps={{
                  strategy: 'fixed',
                  modifiers: [
                    {
                      name: 'preventOverflow',
                      options: {
                        boundary: 'viewport'
                      }
                    }
                  ]
                }}
              />
            );
          }}
        />
      )}
      {error && (
        <span className="error" role="alert">
          {error}
        </span>
      )}
    </div>
  );
};

export default InputDatePicker;
